import { commonClient, type NearbyRestaurantRecord } from '@bip/api-client';
import type { NearbyContext, NearbyFetchResult } from '../nearby.types';

/**
 * Nearby-restaurants fetcher. Goes through the common-service cross-sell
 * hub (`GET /bip-api/common/nearby/restaurants`), which fans out to
 * `restaurants-service /nearby-restaurants` server-side. Response shape
 * is unchanged from the direct-restaurants-client days — the hub is
 * a transparent proxy for this category.
 */
export async function fetchNearbyRestaurants(ctx: NearbyContext): Promise<NearbyFetchResult<NearbyRestaurantRecord>> {
  const res = await commonClient.getNearbyRestaurants({
    latitude: ctx.latitude,
    longitude: ctx.longitude,
    distance: 50,
    // Default fetch limit is 10 (bumped from 4) — matches every other
    // nearby adapter. The strip's Explore button surfaces whenever
    // `items.length > 4`, so the extra rows give the "there's more"
    // signal room to fire.
    limit: ctx.limit ?? 10,
    sortBy: 'distance',
    sortOrder: 'asc',
  });

  if (!res.success || !res.data?.length) return { items: [], total: 0 };

  const exploreHref =
    res.exploreUrl || (ctx.cityName ? `/restaurants?city=${encodeURIComponent(ctx.cityName)}` : '/restaurants');

  return { items: res.data, total: res.meta.totalRecords, exploreHref };
}
